import { render, staticRenderFns } from "./ProposalsList.view.vue?vue&type=template&id=5c84fbee&"
import script from "./ProposalsList.view.vue?vue&type=script&lang=js&"
export * from "./ProposalsList.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c84fbee')) {
      api.createRecord('5c84fbee', component.options)
    } else {
      api.reload('5c84fbee', component.options)
    }
    module.hot.accept("./ProposalsList.view.vue?vue&type=template&id=5c84fbee&", function () {
      api.rerender('5c84fbee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/ProposalsList.view.vue"
export default component.exports